import React, { Component, Fragment } from 'react';
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import BasicInfo from "./BasicInfo";
import isEqual from "lodash/isEqual";
import Model from "./../../../../../models/Location";
import {extend} from "lodash";
import { UPLOAD_DIRECTORY } from '../../../../../constants/Define';
export default class LocationDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
            action: this.props.match.params.id ? "UPDATE" : "CREATE",
            location: new Model({}),
            validation: {},
            isUploading: false,
            isReady: !this.props.match.params.id //Render when create
        };
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        const location = this.state.location || {};
        location[params.name] = params.value
        this.setState({location, isSubmit: false});
    };

    onUploadImage = (file) => {
        this.setState({
            isUploading: true
        });
        this.props.onUploadFile({ file: file.target.files[0], directory: UPLOAD_DIRECTORY.LOCATION, isFile: 1 });
    };

    componentDidMount() {
        const { match } = this.props;
        match.params.id && this.props.getLocation(match.params.id);
    }

    componentWillUnmount() {
        this.props.setLocation(new Model())
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.uploadState !== prevProps.uploadState && this.props.uploadState.file) {
            const location = this.state.location;
            location.image = this.props.uploadState.file.data.fileUrl;
            this.setState({ location, isUploading: false });
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            this.setState({
                isSubmit: true
            });
            this.props.saveLocation({location: this.state.location, props: this.props});
        }

    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.location.name`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.location.code`))
            }
        };
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.location, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.locationState.location && !isEqual(nextProps.locationState.location, this.props.locationState.location) && !nextProps.locationState.isFetching) {
            this.setState({
                location: nextProps.locationState.location,
                isReady: true,
                loading: false,
                isSubmit: false
            });
        }
    }

    render() {
        const { t, match } = this.props;
        const { action, location, isReady, isSubmit, isUploading, validation  } = this.state;
        return (
            <Fragment>{isReady &&
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'locations'}
                        titleHeader={Func.capitalizeFirstLetter((`${t( action === "CREATE" ? 'action.create' : 'action.update')} ${t('item.location.title')}`).toLowerCase())}
                    />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={false}
                            findParentRoute={() => Func.findParentRoute('locations', this.props)}
                            activeComponent={false}
                            onChangeActive={this.onChange}
                            titleActiveComponent={t(`item.banner.active`)}
                            submitButtonRight={true}
                            statusActiveName={`isEnabled`}
                            statusActive={false}
                        >
                        <HMS.FormWrapperItem>
                            <BasicInfo validation={validation} isUploading={isUploading} onUploadImage={this.onUploadImage}  loading={isSubmit} onChange={this.onChange} location={location} action={action}/>
                        </HMS.FormWrapperItem>
                    </HMS.FormActionComponent>
                </HMS.PageListComponent>
            }
            </Fragment>
        );
    }
}
